import { render, staticRenderFns } from "./AddTrainingType.vue?vue&type=template&id=66297da3&"
import script from "./AddTrainingType.vue?vue&type=script&lang=js&"
export * from "./AddTrainingType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports